import React from 'react';
import styles from './Spinner.module.scss';

function ContentSpinner() {
    return <div className={styles.spinner} />;
}

export default ContentSpinner;
